var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUncheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9248 16.625H6.2498C5.76053 16.625 5.36022 16.2312 5.36022 15.75V5.25C5.36022 4.76875 5.76053 4.375 6.2498 4.375H16.9248C17.4141 4.375 17.8144 4.76875 17.8144 5.25V15.75C17.8144 16.2312 17.4141 16.625 16.9248 16.625ZM17.8144 2.625H5.36022C4.38168 2.625 3.58105 3.4125 3.58105 4.375V16.625C3.58105 17.5875 4.38168 18.375 5.36022 18.375H17.8144C18.7929 18.375 19.5936 17.5875 19.5936 16.625V4.375C19.5936 3.4125 18.7929 2.625 17.8144 2.625Z",
    fill: "#DEFFFF",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.35,
    height: 21,
    fill: "white",
    transform: "translate(0.912109)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheck);
export default __webpack_public_path__ + "static/media/uncheck.5e4e0086.svg";
export { ForwardRef as ReactComponent };